export function buildFilename(
  prefix: string,
  name: string | undefined | null,
  suffix: string,
): string {
  const part = [...(name ?? "").replace(/[^\p{L}\p{N}]+/gu, "_").replace(/^_+|_+$/g, "")]
    .slice(0, 64)
    .join("")
    .replace(/_+$/, "");
  return (part ? `${prefix}_${part}` : prefix) + ("." + suffix);
}
